export const environmentList = [
    { code: "SIT",
      environmentName: "System Integration Test",
      managedBy: "Client"
    },
    { code: "UAT",
      environmentName: "User Acceptance Test",
      managedBy: "Client"
    },
    { code: "TRG",
      environmentName: "Training Environment",
      managedBy: "Client"
    },
    { code: "DEV",
      environmentName: "Development Environment",
      managedBy: "Project"
    }
  ];

